/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 *
 * @author Viacheslav Smalenski
 * @version 1.28.0
 * @since 1.28.0
 */

import { icons } from '@/main/assets';
import { ImgStyled } from '@components/common/Block/Img';
import { EFileExtension, MapExtensionToIcon } from '@modules/app/appConstants';
import {
    InquiryInfoAnswerFooterStyled,
    InquiryInfoPageAttachedFileContainerStyled,
    InquiryInfoPageAttachedFileNameStyled,
} from '@pages/PageInquiryInfo/components/styled/InquiryInfoPageStyled';
import { IInquiryInfoNewFile } from '@pages/PageInquiryInfo/types';
import { getFileExtension } from '@utils/formatText';

interface AttachedFilesBlockProps {
    newUploadedFiles: IInquiryInfoNewFile[];
    onFileDetachHandler: (fileId: IInquiryInfoNewFile['fileId']) => void;
}

export const InquiryInfoPageChatFormAttachedFiles = ({
    newUploadedFiles,
    onFileDetachHandler,
}: AttachedFilesBlockProps) => {
    return (
        <>
            {newUploadedFiles?.map((file, index) => (
                <InquiryInfoAnswerFooterStyled key={file.file.name + index}>
                    <InquiryInfoPageAttachedFileContainerStyled key={file.file.name}>
                        <ImgStyled
                            className="medium"
                            src={
                                MapExtensionToIcon[getFileExtension(file.file.name) as EFileExtension] ??
                                icons.defaultFileIcon
                            }
                        />
                        <InquiryInfoPageAttachedFileNameStyled>{file.file.name}</InquiryInfoPageAttachedFileNameStyled>
                    </InquiryInfoPageAttachedFileContainerStyled>
                    <ImgStyled
                        className="cross"
                        src={icons.removeSmallOpacityIcon}
                        width="24px"
                        onClick={() => onFileDetachHandler(file.fileId)}
                    />
                </InquiryInfoAnswerFooterStyled>
            ))}
        </>
    );
};
